import { render, staticRenderFns } from "./TelegramInfo.vue?vue&type=template&id=6748e456&"
import script from "./TelegramInfo.vue?vue&type=script&lang=js&"
export * from "./TelegramInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports